import React from 'react'
import Image, { type StaticImageData } from 'next/image'
import weightLossImage from '@/assets/images/refresh/category-directory/weight-loss.jpg'
import coldReliefImage from '@/assets/images/refresh/category-directory/cold-relief.jpg'
import skinImage from '@/assets/images/refresh/category-directory/skin.jpg'
import digestiveCareImage from '@/assets/images/refresh/category-directory/digestive-care.jpg'
import allergiesImage from '@/assets/images/refresh/category-directory/allergies.jpg'
import mentalHealthImage from '@/assets/images/refresh/category-directory/mental-health.jpg'
import sleepImage from '@/assets/images/refresh/category-directory/sleep.jpg'
import painReliefImage from '@/assets/images/refresh/category-directory/pain-relief.jpg'
import respiratoryImage from '@/assets/images/refresh/category-directory/respiratory.jpg'
import heartHealthImage from '@/assets/images/refresh/category-directory/heart-health.jpg'
import diabetesCareImage from '@/assets/images/refresh/category-directory/diabetes-care.jpg'
import mensHealthImage from '@/assets/images/refresh/category-directory/mens-health.jpg'
import womensHealthImage from '@/assets/images/refresh/category-directory/womens-health.jpg'
import classes from './Background.module.css'

/** Backend `background` keys with a pre-blurred card photo. Unsupported keys are omitted. */
export type CategoryDirectoryBackgroundKey =
    | 'weight-loss'
    | 'cold-relief'
    | 'skin'
    | 'digestive-care'
    | 'allergies'
    | 'mental-health'
    | 'sleep'
    | 'pain-relief'
    | 'respiratory'
    | 'heart-health'
    | 'diabetes-care'
    | 'mens-health'
    | 'womens-health'

const BACKGROUND_REGISTRY: Record<CategoryDirectoryBackgroundKey, StaticImageData> = {
    'weight-loss': weightLossImage,
    'cold-relief': coldReliefImage,
    skin: skinImage,
    'digestive-care': digestiveCareImage,
    allergies: allergiesImage,
    'mental-health': mentalHealthImage,
    sleep: sleepImage,
    'pain-relief': painReliefImage,
    respiratory: respiratoryImage,
    'heart-health': heartHealthImage,
    'diabetes-care': diabetesCareImage,
    'mens-health': mensHealthImage,
    'womens-health': womensHealthImage,
}

export function isCategoryDirectoryBackgroundKey(
    background: string,
): background is CategoryDirectoryBackgroundKey {
    return background in BACKGROUND_REGISTRY
}

interface BackgroundProps {
    background: CategoryDirectoryBackgroundKey
}

export default function Background({ background }: BackgroundProps) {
    const src = BACKGROUND_REGISTRY[background]

    return (
        <div className={classes.root} aria-hidden>
            <Image
                src={src}
                alt=""
                fill
                sizes="(max-width: 48em) 230px, 272px"
                className={classes.image}
                priority={false}
                loading="lazy"
                decoding="async"
            />
        </div>
    )
}
